import { TableMap } from 'prosemirror-tables';
import { findParentNodeClosestToPos } from 'prosemirror-utils';
export function moveCursorToCell(composer, rowIndex, colIndex) {
  let tableNodeAndPos = composer.state.currentlyActiveTable;
  if (!tableNodeAndPos) {
    return;
  }
  let tableNode = tableNodeAndPos.node;
  let tableStartingPosition = tableNodeAndPos.start;
  let cellStartingPosition = TableMap.get(tableNode).positionAt(rowIndex, colIndex, tableNode);
  let newCursorPosition = tableStartingPosition + cellStartingPosition;
  composer.commands.setSelection(newCursorPosition, newCursorPosition);
}
export function getColumnCount(currentlyActiveTable) {
  if (!currentlyActiveTable) {
    return;
  }
  let tableNode = currentlyActiveTable;
  let tableMap = TableMap.get(tableNode);
  return tableMap.width;
}
export { getResponsiveClasses } from '@intercom/composer-core';
export function nodeIsInLayoutOrSection(resolvedPosition, editorState) {
  let nodePredicate = node => {
    return node.type === editorState.schema.nodes.table && (node.attrs.container || node.attrs.responsive);
  };
  let parentNode = findParentNodeClosestToPos(resolvedPosition, nodePredicate);
  if (parentNode) {
    return true;
  }
  return false;
}